import {useInvoices} from '../hooks/useInvoices';
import {Button} from "@mantine/core";
import {AiOutlineMail} from "react-icons/ai";

interface SendRecordButtonProps {
    selectedIds: string[];
    onSendComplete?: () => void;
}

export const SendRecordButton = ({selectedIds, onSendComplete}: SendRecordButtonProps) => {

    const {sendInvoices} = useInvoices();

    const disabled = selectedIds.length === 0;

    return (<Button disabled={disabled}
                    onClick={() => {
                        sendInvoices(selectedIds);
                        onSendComplete?.();
                    }}
                    leftSection={<AiOutlineMail/>}
    >Send</Button>);
};
